import React, { useContext, useState } from "react";
import { Button } from "antd";
import { ModalContext } from "context/ModalContext";
import TableComponent from "./../../components/widgets/table/index";
import AddKycRequirement from "./../../components/widgets/forms/setup/AddKycRequirement";
import AddRiskRequirement from "./../../components/widgets/forms/setup/AddRiskRequirement";
import BasicDetails from "components/setup/BasicDetails";
import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { fetch_product_details } from "services/apiSrv";
import Loader from "components/widgets/loader";

export default function ProductRequirementsConfig() {
  const { modalShow, modalClose } = useContext(ModalContext);

  // Example product table data
  const [productItems] = useState([
    { id: 1, name: "Comprehensive Auto", ref: "AUTO123", underwriters: "ABC Insurance", productImage: "auto.jpg" },
  ]);

  // KYC and Risk Requirements state
  const [kycItems, setKycItems] = useState([]);
  const [riskItems, setRiskItems] = useState([]);

  // Handle add for KYC and Risk requirements
  const handleAddKyc = (requirement) => {
    if (!kycItems.some((item) => item.id === requirement.id)) {
      setKycItems((prevItems) => [...prevItems, requirement]);
    }
  };

  const handleAddRisk = (requirement) => {
    if (!riskItems.some((item) => item.id === requirement.id)) {
      setRiskItems((prevItems) => [...prevItems, requirement]);
    }
  };

  // Handle remove for KYC and Risk items
  const handleRemoveKyc = (id) => {
    setKycItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  const handleRemoveRisk = (id) => {
    setRiskItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  // Table fields for products
  const productTableFields = [
    { name: "Product Image" },
    { name: "Name" },
    { name: "Underwriters" },
    { name: "Ref" },
  ];

  const productRowData = [
    { type: "image", field: "productImage", domain: "" },
    { type: "text", field: "name" },
    { type: "text", field: "underwriters" },
    { type: "text", field: "ref" },
  ];

  // Table fields for KYC and Risk
  const kycRiskTableFields = [
    { name: "Name" },
    { name: "Description" },
    { name: "Actions" },
  ];

  const kycRiskRowData = [
    { type: "text", field: "name" },
    { type: "text", field: "description" },
    { type: "text", field: "actions" },
  ];


    const { id: productSystemRef } = useParams();

    const { data, isLoading, isError, error, refetch } = useQuery({
      queryKey: ["productDetails", productSystemRef],
      queryFn: () => fetch_product_details(productSystemRef),
      enabled: !!productSystemRef,
      retry: 2,
      staleTime: 5 * 60 * 1000,
    });

    if (isLoading) {
      return <Loader />;
    }

    if (isError) {
      return <p>Error fetching product details: {error?.message || "Something went wrong"}</p>;
    }

    if (!data?.data) {
      return <p>No product data available.</p>;
    }

    const { productPolicyConfig, productRequirements } = data.data[0];

    let risks = [];
    let kycs = []

    if(productRequirements.length > 0){
      const risksRequiremments = productRequirements.filter((requirement) => requirement.type === "RISK");
      risks.push(...risksRequiremments);

      const kycsRequiremments = productRequirements.filter((requirement) => requirement.type === "KYC")
      kycs.push(...kycsRequiremments);
    }

  return (
    <div className="p-4">
     <BasicDetails />

      {/* KYC Requirements */}
      <div className="mb-5">
        <h2 className="fs-4 my-3 fw-semibold">KYC Requirements</h2>
        <div className=" mb-4">
        <div className="#card-body">
          <ul className="list-group list-group-flush">
            {kycs.map((field, index) => (
              <li key={index} className="list-group-item px-3">
                <div className="#row">
                  <div className="col-12 col-md-6">
                    <p className="">
                      <strong className="text-dark">✅ </strong>  <span className="text-muted">{field.name}</span>
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
        <AddKycRequirement refetchProductDetails={refetch} requirementsItems={kycs} onSubmit={handleAddKyc} />
      </div>

      {/* Risk Requirements */}
      <div className="mb-5">
        <h2 className="fs-4 mb-3 fw-semibold">Risk Requirements</h2>
                <div className=" mb-4">
        <div className="#card-body">
          <ul className="list-group list-group-flush">
            {risks.map((field, index) => (
              <li key={index} className="list-group-item px-3">
                <div className="row">
                  <div className="col-12 col-md-6">
                    <p className="mb-1">
                      <strong className="text-dark">✅ </strong> <span className="text-muted">{field.name}</span>
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
        <AddRiskRequirement refetchProductDetails={refetch} requirementsItems={risks} onSubmit={handleAddRisk} />
      </div>
    </div>
  );
}